import ApiClient from '../ApiClient';

class WgptSamlProvidersAPI extends ApiClient {
  constructor() {
    super('saml/providers', { accountScoped: true, wgpt: true });
  }
}

export default new WgptSamlProvidersAPI();
